import React, { useMemo } from 'react';

interface Props {
    salesInvoice: any;
    salesInvoiceDetails?: any[]; // Posiciones de la factura
}

const SalesInvoiceTotal = ({ salesInvoice, salesInvoiceDetails = [] }: Props) => {
    // Función para formatear como moneda CLP
    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    };

    // Usar los valores de la factura directamente (ya están calculados en el backend)
    const totals = useMemo(() => {
        const totalNeto = typeof salesInvoice?.total_neto === 'string' 
            ? parseFloat(salesInvoice.total_neto) 
            : (salesInvoice?.total_neto || 0);
        
        const totalTax = typeof salesInvoice?.total_tax === 'string' 
            ? parseFloat(salesInvoice.total_tax) 
            : (salesInvoice?.total_tax || 0);
        
        const total = typeof salesInvoice?.total_sale === 'string' 
            ? parseFloat(salesInvoice.total_sale) 
            : (salesInvoice?.total_sale || 0);
        
        return {
            neto: totalNeto,
            tax: totalTax,
            total: total
        };
    }, [salesInvoice]);

    return (
        <div className="sales-invoice-total">
            <div className="row justify-content-end">
                <div className="col-md-3">
                    <div className="form-group mb-2">
                        <label htmlFor="totalNet">Total Neto:</label>
                        <input
                            type="text"
                            id="totalNet"
                            className="form-control"
                            value={formatCurrency(totals.neto)}
                            disabled
                        />
                    </div>

                    <div className="form-group mb-2">
                        <label htmlFor="totalTax">Total Impuestos:</label>
                        <input
                            type="text"
                            id="totalTax"
                            className="form-control"
                            value={formatCurrency(totals.tax)}
                            disabled
                        />
                    </div>

                    <div className="form-group mb-2">
                        <label htmlFor="totalSale">Total:</label>
                        <input
                            type="text"
                            id="totalSale"
                            className="form-control"
                            value={formatCurrency(totals.total)}
                            disabled
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesInvoiceTotal;
